import customAxios from "../../customAxios";
import { REMOVE_IS_APPROVE_DRIVER } from "../../routes";

const removeIsAproveDriver = async (_id: string) => {
  var thisUrl = REMOVE_IS_APPROVE_DRIVER + "/" + _id;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_ALL_SERVICE: error });
  }
};

export default removeIsAproveDriver;
